import React, { /*useEffect, */ useState, useEffect } from "react";
// import { withAuthenticator } from "@aws-amplify/ui-react";
import { useAuth0 } from "@auth0/auth0-react";
// import "@aws-amplify/ui-react/styles.css";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { styled, createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import MuiDrawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import MuiAppBar from "@mui/material/AppBar";
import Tooltip from "@mui/material/Tooltip";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Container from "@mui/material/Container";
import useMediaQuery from "@mui/material/useMediaQuery";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItemButton from "@mui/material/ListItemButton";
import { useFeatureFlag } from "./context/featureFlagContext";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import BarChartIcon from "@mui/icons-material/BarChart";
import Button from "@mui/material/Button";
import { ListItem, Switch, Stack, Fab, Modal, CircularProgress } from "@mui/material";
import { clearUserCache } from "./authUtils";
import { Card, CardContent } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import UploadFile from "@mui/icons-material/UploadFile";
import DashboardSVGIcon from "./Assets/Images/dashboard.svg";
import DashboardSVGIconActive from "./Assets/Images/dashboard-active.svg";
import InsightsIcon from "@mui/icons-material/Insights";
import MonitorHeartOutlinedIcon from "@mui/icons-material/MonitorHeartOutlined";
import ShieldIcon from "@mui/icons-material/ShieldOutlined";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import OnboardingQuestionnaire from "./OnboardingQuestionnaire";
import BIReportingAnnouncement from "./BIReportingAnnouncement";
import AnalyticsTracker from "./analytics/AnalyticsTracker";
import { isPlatformAdmin } from "./utils/isPlatformAdmin";
import InviteUsersModal from "./InviteUsersModal";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import IntegrationInstructionsIcon from "@mui/icons-material/IntegrationInstructions";
import CompanyCardSVGIcon from "./Assets/Images/companyCards.svg";
import CompanyCardSVGIconActive from "./Assets/Images/companyCards-active.svg";
import SettingSVGIcon from "./Assets/Images/settings.svg";
import SettingSVGIconActive from "./Assets/Images/settings-active.svg";
import QuestionSVGIcon from "./Assets/Images/questions.svg";
import QuestionSVGIconActive from "./Assets/Images/questions-active.svg";
import Rubik from "./Assets/Fonts/Rubik-Regular.ttf";
import { ColorEnum } from "./Assets/Colors/ColorsEnum";
import logoutIcon from "./Assets/Images/logoutIconNew.svg";
import filterIcon from "./Assets/Images/filterIconNew.svg";
import { Menu, MenuItem } from "@mui/material";
import CreateCompanyModal from "./CreateCompanyModal";
import NotificationDrawer from "./NotificationDrawer/NotificationDrawer";
import HelpCenter from "./components/HelpCenter/HelpCenter";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useSearchQuery } from "./context/searchContext";
import SearchBar from "../src/utils/SearchBar";
import CloseIcon from "@mui/icons-material/Close";
import { useProspectsAR } from "./context/prospectsARContext";
import FileUploadModal from "./FileUploadModal";
import ProspectFileUploadModal from "./ProspectFileUploadModal";
import { useFilter } from './context/filterContext';
import { useRolePermissions } from './context/RolePermissionsContext';
import { RestrictedAction } from './components/RestrictedAction';
import RequestStatusIcon from "./Assets/Images/reports.svg";
import RequestStatusIconActive from "./Assets/Images/reports.svg";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useSegment } from './context/segmentContext';
import WidgetsOutlinedIcon from '@mui/icons-material/WidgetsOutlined';
import getTenantIdFromURL from "./utils/getTenantIdFromURL";
import { recordTenantVisit } from "./utils/recentTenants";
import { useSelector } from "react-redux";
import ReactGA from "react-ga4";
import { getTenantById } from "./api/tenantApi";
import { getEntitlements } from "./api/billingApi";
import { useStatus } from "./context/statusContext";
import PortfolioCopilot from "./components/PortfolioCopilot";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import CurrencyExchangeOutlinedIcon from "@mui/icons-material/CurrencyExchangeOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import CloudQueueOutlinedIcon from "@mui/icons-material/CloudQueueOutlined";
import PaymentPlatformQuickUploadFlow from "./components/PaymentPlatformQuickUploadFlow";
import { withSupportPreview } from "./utils/supportPreview";
import { isCurrencyRiskEnabled, isExecutiveDashboardEnabled } from "./config/tenantRollouts";
import { getDistributorBrand } from "./utils/distributorBranding";


const trackingID = "G-9QZ6JYFX19";
const adminTrackingId = "G-VYW7DRSVZE";

const drawerWidth = 240;

function DistributorBrandLockup({ distributor }) {
    const brand = getDistributorBrand(distributor);
    const [imageFailed, setImageFailed] = useState(false);
    useEffect(() => { setImageFailed(false); }, [brand.logoUrl]);
    return (
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", minWidth: 120, maxWidth: 170 }}>
            {brand.logoUrl && !imageFailed ? (
                <Box component="img" src={brand.logoUrl} alt={brand.logoAlt} onError={() => setImageFailed(true)}
                    sx={{ maxWidth: 150, width: "auto", height: 38, objectFit: "contain", bgcolor: "#fff", borderRadius: "5px", px: .75, py: .35 }} />
            ) : (
                <Typography aria-label={`${brand.name} logo`} sx={{ color: "#fff", fontSize: 17, fontWeight: 900, lineHeight: 1.1, textAlign: "center" }}>
                    {brand.name}
                </Typography>
            )}
            <Typography sx={{ color: "rgba(255,255,255,.76)", fontSize: 9.5, fontWeight: 650, mt: .45, letterSpacing: ".035em" }}>By CrediArc</Typography>
        </Box>
    );
}

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
    position: "fixed",
    zIndex: theme.zIndex.drawer,
    backgroundColor: "#ECEDF0",
    boxShadow: "none",
    border: "none",
    transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const Drawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
    "& .MuiDrawer-paper": {
        position: "relative",
        whiteSpace: "nowrap",
        backgroundColor: ColorEnum.DARK_BLUE,
        width: drawerWidth,
        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        boxSizing: "border-box",
        ...(!open && {
            overflowX: "hidden",
            transition: theme.transitions.create("width", {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            width: theme.spacing(7),
            [theme.breakpoints.up("sm")]: {
                width: theme.spacing(9),
            },
        }),
    },
}));

const rubikFont = {
    fontFamily: "Rubik",
    fontStyle: "normal",
    fontDisplay: "swap",
    fontWeight: 500,
    src: `
    local('Rubik'),
    url(${Rubik}) format('truetype')
  `,
};

const defaultTheme = createTheme({
    palette: {
        background: {
            // paper: "#ECEDF0",
            default: "#ECEDF0",
        },
    },
    typography: {
        fontFamily: "Rubik, sans-serif",
    },
    components: {
        MuiContainer: {
            styleOverrides: {
                root: {
                    "@media (min-width: 1200px)": {
                        maxWidth: "none",
                    },
                },
            },
        },
    },
    overrides: {
        MuiCssBaseline: {
            "@global": {
                "@font-face": [rubikFont],
            },
        },
    },
});

function Dashboard({ adminAction }) {
    const {
        user,
        logout,
        // isAuthenticated,
        // isLoading,
        // getAccessTokenSilently,
        // loginWithRedirect,
    } = useAuth0();
    const isMobile = useMediaQuery(defaultTheme.breakpoints.down("sm"));

    const [headerText, setHeaderText] = useState("");
    const [segmentsExpanded, setSegmentsExpanded] = useState(false);
    const location = useLocation();
    const isPlatformWorkspace = location.pathname.startsWith("/platform");
    const navigate = useNavigate();
    const [isAdminUser, setIsAdminUser] = useState(false);
    const [isloading, setIsLoading] = useState(true);
    const [notificationCount, setNotificationCount] = useState(0);
    const [loadingButton, setLoadingButton] = useState(null);
    const [tenantName, setTenantName] = useState("");
    const [clientDistributor, setClientDistributor] = useState(null);
    const [inviteTeamOpen, setInviteTeamOpen] = useState(false);
    const [counter, setCounter] = useState(0);
    const [isAREnabled, setIsAREnabled] = useState(false);
    const [tenantType, setTenantType] = useState("regular");
    const [logo, setLogo] = useState(null);
    const [darkLogo, setDarkLogo] = useState(null);
    const [anchorMenu, setAnchorMenu] = React.useState(null);
    const [paymentActionAnchor, setPaymentActionAnchor] = useState(null);
    const paymentPlatformUploadRef = React.useRef(null);
    const [notificationDrawerOpen, setNotificationDrawerOpen] = useState(false);
    const [helpOpen, setHelpOpen] = useState(false);
    const [portfolioCopilotContext, setPortfolioCopilotContext] = useState(null);
    const { searchQuery, setSearchQuery } = useSearchQuery();
    const { isProspects, setProspects } = useProspectsAR();
    const { status, setStatus } = useStatus();
    const [isModalOpen, setModalOpen] = useState(false);
    const [popupOpen, setPopupOpen] = useState(false);
    const [isLimitModalOpen, setIsLimitModalOpen] = useState(false);

    const handleOpenLimitModal = () => setIsLimitModalOpen(true);
    const handleCloseLimitModal = () => setIsLimitModalOpen(false);

    // Consolidated tenant handling
    const { setSelectedSegment, segments, loading: segmentsLoading, selectedSegment } = useSegment();
    const isAdmin = useSelector((state) => state.userInfo.isAdmin);
    const userEmail = useSelector((state) => state.userInfo.email);
    const platformAdmin = isPlatformAdmin(userEmail, isAdmin);
    const {
        permissions,
        isSupportPreview,
        supportPreview,
    } = useRolePermissions();
    const [tenantId, setTenantId] = useState();

    const currentTenant = useSelector((state) => state.userInfo.tenantId);
    const isDistributor = useSelector((state) => state.userInfo.isDistributor);
    const URLTenant = getTenantIdFromURL();
    const isDistributorAdminRoute = location.pathname.startsWith("/platform/distributor/");

    // Use URLTenant for admin AND for a distributor viewing one of their client tenants
    // (/tenant-dashboard/:id); regular tenant users always resolve to their own tenant.
    // Platform distributor detail routes contain a distributor ID, not a tenant ID.
    const activeTenantId = isDistributorAdminRoute
        ? null
        : ((isAdmin || (isDistributor && URLTenant)) ? URLTenant : currentTenant);
    const isExecutiveDashboard = Boolean(activeTenantId) && isExecutiveDashboardEnabled(activeTenantId);
    const adminDestination = (path) => withSupportPreview(path, location.search);

    // Child pages occasionally navigate without copying query parameters. Restore
    // the preview marker so the admin cannot silently fall back to full access.
    useEffect(() => {
        if (!isSupportPreview || !supportPreview?.id) return;
        if (new URLSearchParams(location.search).get("viewAsUser")) return;
        navigate(
            withSupportPreview(location.pathname, `?viewAsUser=${encodeURIComponent(supportPreview.id)}`),
            { replace: true }
        );
    }, [
        isSupportPreview,
        location.pathname,
        location.search,
        navigate,
        supportPreview?.id,
    ]);

    // Insurance layer is surfaced when the tenant has it enabled — either via the plan/features
    // entitlement (`insurance`) OR the tenant-level `isInsuranceEnabled` flag (set on the tenant
    // page / create-tenant modal, alongside AR and D&B). `insuranceFlag` is set in fetchTenantName.
    const [insuranceEntitled, setInsuranceEntitled] = useState(false);
    const [insuranceFlag, setInsuranceFlag] = useState(false);
    const insuranceEnabled = insuranceEntitled || insuranceFlag;
    useEffect(() => {
        let cancelled = false;
        if (!activeTenantId) { setInsuranceEntitled(false); return; }
        getEntitlements(activeTenantId)
            .then((res) => { if (!cancelled) setInsuranceEntitled(!!(res?.data?.insurance)); })
            .catch(() => { if (!cancelled) setInsuranceEntitled(false); });
        return () => { cancelled = true; };
    }, [activeTenantId]);

    const selectTenantId = () => {
        if (isAdmin) setTenantId(URLTenant);
        else setTenantId(currentTenant);
    };

    const fetchTenantName = async () => {
        if (!activeTenantId) return;
        try {
            const result = await getTenantById(activeTenantId);
            const tenantInfo = result.data;
            setIsAREnabled(tenantInfo.isAREnabled);
            setTenantType(tenantInfo.tenantType || "regular");
            setInsuranceFlag(!!tenantInfo.isInsuranceEnabled);
            setTenantName(tenantInfo.name);
            setCounter(tenantInfo.counter);
            setClientDistributor(tenantInfo.distributor || null);
        } catch (error) {
            console.error("Error fetching tenant info:", error);
            setClientDistributor(null);
        }
    };

    useEffect(() => {
        selectTenantId();
    }, []);

    // Remember when a platform admin enters a tenant's dashboard (any path — switcher, direct URL,
    // or Platform Console), so that tenant floats to the top of the Platform Console list.
    useEffect(() => {
        if (adminAction && URLTenant && (isAdmin || platformAdmin)) {
            recordTenantVisit(URLTenant);
        }
    }, [adminAction, URLTenant, isAdmin, platformAdmin]);

    useEffect(() => {
        if (isAdmin) {
            ReactGA.initialize(adminTrackingId);
        } else {
            ReactGA.initialize(trackingID);
        }

        ReactGA.send({ hitType: "pageview", page: window.location.pathname });

        fetchTenantName();
    }, [activeTenantId]);

    useEffect(() => {
        setSearchQuery();
      if (adminAction) {
  try {
    const tenantNamesRaw = localStorage.getItem("tenantNames");
    if (!tenantNamesRaw) {
      console.warn("tenantNames not found in localStorage");
      return;
    }

    const tenantNames = JSON.parse(tenantNamesRaw);
    if (!tenantNames || typeof tenantNames !== "object") {
      console.error("tenantNames is invalid");
      return;
    }

    if (!URLTenant || !tenantNames[URLTenant]) {
      console.error("Invalid or missing URLTenant:", URLTenant);
      return;
    }

    setTenantName(tenantNames[URLTenant]);
    setTenantId(URLTenant);
  } catch (err) {
    console.error("Failed to parse tenantNames from localStorage", err);
  }
}
        // if (!localStorage.getItem("subId")) loginWithRedirect();

        // if (!isAuthenticated && !isLoading) {
        //     loginWithRedirect();
        // }
        if (location.pathname === "/filteredSummary") setProspects(false);
    }, []);

    useEffect(() => {
        const fetchAdminStatus = async () => {
            const adminStatus = isAdmin;
            setIsAdminUser(adminStatus);
            setIsLoading(false);

            if (location.pathname === "/") {
                if (adminStatus) {
                    setHeaderText("Admin Console");
                } else {
                        selectedSegment? setHeaderText(selectedSegment.name) : setHeaderText("Dashboard");
                    }
            } else if (location.pathname === "/company") {
                setHeaderText("Company Cards");
            } else if (location.pathname.indexOf("/company") > -1) {
                setHeaderText("Company");
            } else if (location.pathname === "/questions") {
                setHeaderText("Questions");
            } else if (location.pathname === "/settings") {
                setHeaderText("Settings");
            } else if (location.pathname === "/prospects") {
                setHeaderText("Prospects");
            } else if (location.pathname === "/admin") {
                setHeaderText("Admin");
            } else if (location.pathname === "/arsummary") {
                setHeaderText("AR Summary");
            } else if (location.pathname === "/requeststatus") {
                setHeaderText("Request Status");
            } else if (location.pathname.includes("/uploadcompanyfiles")) {
                setHeaderText("Upload Company Files");
            } else if (location.pathname.includes("/assessments")) {
                setHeaderText("MCA / Loan Assessments");
            } else if (location.pathname.includes("/reporting")) {
                setHeaderText("BI & Reporting");
            } else if (location.pathname.includes("/portfolio-risk")) {
                setHeaderText("Portfolio Risk Intelligence");
            } else if (location.pathname.includes("/currency-risk")) {
                setHeaderText("Currency Risk");
            } else if (location.pathname.includes("/billing")) {
                setHeaderText("Billing & Plans");
            } else if (location.pathname.includes("/platform")) {
                setHeaderText("Platform Console");
            } else if (location.pathname.endsWith("/api")) {
                setHeaderText("API & Documentation");
            }
        };

        fetchAdminStatus();
    }, [location]);

    useEffect(() => {
        if (!isAREnabled && !isProspects) {
            setProspects(true);
        }
    }, [isAREnabled, setProspects, isProspects]);

    useEffect(() => {
        fetchLogo();
    }, [tenantId, isAdmin, currentTenant]);

    const fetchLogo = async () => {
        try {
            const baseUrl =
                "https://crediarc-content130816-staging.s3.amazonaws.com/public/logos/";
            const logoUrl = `${baseUrl}${currentTenant}.svg`;
            const darkLogoUrl = `${baseUrl}${currentTenant}-dark.svg`;

            let response = await fetch(logoUrl);
            if (!response.ok) {
                throw new Error(`Failed to fetch logo: ${response.statusText}`);
            }
            let blob = await response.blob();
            let url = URL.createObjectURL(blob);
            setLogo(url);

            response = await fetch(darkLogoUrl);
            if (!response.ok) {
                throw new Error(`Failed to fetch dark logo: ${response.statusText}`);
            }
            blob = await response.blob();
            url = URL.createObjectURL(blob);
            setDarkLogo(url);
        } catch (error) {
            console.log("Error fetching logos", error);
        }
    };

    const handleGoToDashboard = () => {
        if (adminAction) navigate(adminDestination(`/tenant-dashboard/${URLTenant}`));
        else navigate(`/`);
        return null;
    };
    const isDashboardRoute = location.pathname === "/" ||
        (adminAction && location.pathname === `/tenant-dashboard/${URLTenant}`);

    const handleGoToCompanies = () => {
        if (adminAction) navigate(adminDestination(`/tenant-dashboard/${URLTenant}/company`));
        else navigate(`/company`);
        return null;
    };

    const handleGoToQuestions = () => {
        if (adminAction) navigate(adminDestination(`/tenant-dashboard/${URLTenant}/questions`));
        else navigate(`/questions`);
        return null;
    };

    const handleGoToSettings = () => {
        if (adminAction) navigate(adminDestination(`/tenant-dashboard/${URLTenant}/settings`));
        else navigate(`/settings`);
        return null;
    };

    const handleGoToReporting = () => {
        if (adminAction) navigate(adminDestination(`/tenant-dashboard/${URLTenant}/reporting`));
        else navigate(`/reporting`);
        return null;
    };

    const handleGoToPortfolioRisk = () => {
        if (adminAction) navigate(adminDestination(`/tenant-dashboard/${URLTenant}/portfolio-risk`));
        else navigate(`/portfolio-risk`);
        return null;
    };

    const handleGoToCurrencyRisk = () => {
        if (adminAction) navigate(adminDestination(`/tenant-dashboard/${URLTenant}/currency-risk`));
        else navigate(`/currency-risk`);
        return null;
    };

    const handleGoToInsurance = () => {
        if (adminAction) navigate(adminDestination(`/tenant-dashboard/${URLTenant}/insurance`));
        else navigate(`/insurance`);
        return null;
    };

    const handleGoToBilling = () => {
        if (adminAction) navigate(adminDestination(`/tenant-dashboard/${URLTenant}/billing`));
        else navigate(`/billing`);
        return null;
    };

    const handleGoToPlatform = () => {
        // The Platform Console is a global admin surface, not a tenant sub-page.
        // Always use an absolute route so an active dashboard query (for example
        // `?view=atrisk`) cannot turn the destination into `?view=atrisk/platform`.
        if (isSupportPreview) {
            window.location.assign("/platform");
            return null;
        }
        navigate("/platform");
        return null;
    };

    const handleGoToApi = () => {
        if (adminAction) navigate(adminDestination(`/tenant-dashboard/${URLTenant}/api`));
        else navigate(`/api`);
        return null;
    };

    const handleGoToRequestStatus = () => {
        try {
            if (adminAction) {
                navigate(adminDestination(`/tenant-dashboard/${URLTenant}/requeststatus`));
            } else {
                navigate(`/requeststatus`);
            }
        } catch (error) {
            console.error("Navigation error:", error);
            setOpen(true);
        }
    };

    const handleGoToUploadCompanyFiles = () => {
        if (adminAction) navigate(adminDestination(`/tenant-dashboard/${URLTenant}/uploadcompanyfiles`));
        else navigate(`/uploadcompanyfiles`);
        return null;
    };

    const handleGoToAssessments = () => {
        if (adminAction) navigate(adminDestination(`/tenant-dashboard/${URLTenant}/assessments`));
        else navigate(`/assessments`);
        return null;
    };

    const handlePaymentPlatformAction = (action) => {
        setPaymentActionAnchor(null);
        if (action === "uploadData") {
            paymentPlatformUploadRef.current?.open();
            return;
        }
        const basePath = adminAction
            ? adminDestination(`/tenant-dashboard/${URLTenant}/assessments`)
            : "/assessments";
        const separator = basePath.includes("?") ? "&" : "?";
        navigate(`${basePath}${separator}${action}=1`);
    };

    const handleGoToAdmin = () => {
        navigate("/");
        return null;
    };

    const clearProspectKeys = () => {
        for (let key in localStorage) {
            if (key.startsWith("prospectValue")) {
                localStorage.removeItem(key);
            }
        }
    };

    const handleLogout = () => {
        logout();
        localStorage.removeItem("subId");
        clearProspectKeys();
        clearUserCache(); // Clear user metadata cache on logout
        // return <CallbackPage origin={"loader"} />;
    };

    const [open, setOpen] = React.useState(() => !isMobile);
    useEffect(() => {
        if (isMobile) setOpen(false);
    }, [isMobile, location.pathname]);
    const toggleDrawer = () => {
        setOpen(!open);
    };

    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        if (notificationDrawerOpen) {
            handleClose();
        } else {
            setNotificationDrawerOpen(true);
            setAnchorEl(event.currentTarget);
        }
    };

    const handleClose = async () => {
        setNotificationDrawerOpen(false);
        setAnchorEl(null);
    };

    const openModal = () => setModalOpen(true);
    const closeModal = () => setModalOpen(false);

    const handleMarkAll = async () => {
        setAnchorEl(null);
        // Implementation for marking all alerts as read
    };

    const handleMenu = (event) => {
        setAnchorMenu(event.currentTarget);
    };
    const handleCloseMenu = (event) => {
        setAnchorMenu(false);
    };

    const handleOnClickBuyMoreCompanies = async () => {
        // Implementation for buying more companies
    };

    const AntSwitch = styled(Switch)(({ theme }) => ({
        width: 28,
        height: 16,
        padding: 0,
        display: "flex",
        "&:active": {
            "& .MuiSwitch-thumb": {
                width: 15,
            },
            "& .MuiSwitch-switchBase.Mui-checked": {
                transform: "translateX(9px)",
            },
        },
        "& .MuiSwitch-switchBase": {
            padding: 2,
            "&.Mui-checked": {
                transform: "translateX(12px)",
                color: "#fff",
                "& + .MuiSwitch-track": {
                    opacity: 1,
                    backgroundColor:
                        theme.palette.mode === "dark" ? "#177ddc" : "#1890ff",
                },
            },
        },
        "& .MuiSwitch-thumb": {
            boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
            width: 12,
            height: 12,
            borderRadius: 6,
            transition: theme.transitions.create(["width"], {
                duration: 200,
            }),
        },
        "& .MuiSwitch-track": {
            borderRadius: 16 / 2,
            opacity: 1,
            backgroundColor:
                theme.palette.mode === "dark"
                    ? "rgba(255,255,255,.35)"
                    : "rgba(0,0,0,.25)",
            boxSizing: "border-box",
        },
    }));

    const open1 = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;
    const handleClosePopup = () => {
        setPopupOpen(false);
    };
    const handleSettingsClick = () => {
        handleClosePopup();
        navigate("/settings/AREnableRequest");
    };
    const handleSwitchClick = (e) => {
        const newValue = e.target.checked;
        
        // If AR is enabled, allow switching freely
        if (isAREnabled) {
            setProspects(newValue);
        } else {
            // If AR is disabled and user is trying to switch to AR (newValue = false), show error
            if (!newValue) {
                setPopupOpen(true);
            } else {
                // If AR is disabled and user is switching to prospects (newValue = true), allow it
                setProspects(newValue);
            }
        }
    };
    const { isFeatureFlag, setFeatureFlag } = useFeatureFlag();
    const {
        show_al_chat,
        show_billing,
        show_company,
        show_dashboard,
        show_questions,
        show_reports,
        show_settings,
        show_vendor_supply_chain,
        show_request_status = true,
    } = isFeatureFlag?.["Left_SlideBar"] || {};

    const { show_add_company_button } = isFeatureFlag?.["Buttons"] || {};

    const [isReportsAvailable, setReportsAvailable] = useState(false);
    const [isVendorPageAvailable, setVendorPageAvailable] = useState(false);

    const { handleFilterOpen } = useFilter();

    const [fileUploadModalOpen, setFileUploadModalOpen] = useState(false);
    const [prospectFileUploadModalOpen, setProspectFileUploadModalOpen] = useState(false);
    
    const handleProspectFileUpload = async (file) => {
        console.log('Uploading file:', file);
        await new Promise(res => setTimeout(res, 1000));
    };

    const onNotificationCountChange = (count) => {
        setNotificationCount(count);
    };

    return (
      <ThemeProvider theme={defaultTheme}>
        <Box sx={{ display: "flex" }}>
          <CssBaseline />
          <AnalyticsTracker />
          <OnboardingQuestionnaire />
          <BIReportingAnnouncement />
          <PortfolioCopilot
            tenantId={activeTenantId}
            tenantName={tenantName}
            scope={isProspects ? "prospects" : "ar"}
            supplementalContext={portfolioCopilotContext?.tenantId === activeTenantId ? portfolioCopilotContext?.data : null}
            visible={Boolean(show_add_company_button && activeTenantId)}
          />
          <InviteUsersModal
            open={inviteTeamOpen}
            onClose={() => setInviteTeamOpen(false)}
            tenant={{ id: activeTenantId, name: tenantName || "your team" }}
          />
          <AppBar
            position="absolute"
            data-track-area={`${headerText || "application"} page header`}
            sx={{
                        backgroundColor: isExecutiveDashboard ? "rgba(247,249,252,.96)" : "#ECEDF0",
                        borderBottom: isExecutiveDashboard ? "1px solid #e5eaf2" : "none",
                        backdropFilter: isExecutiveDashboard ? "blur(14px)" : "none",
                        width: { xs: "100%", sm: `calc(100% - ${open ? drawerWidth : 0}px - ${notificationDrawerOpen ? 300 : 0}px)` },
                        marginLeft: { xs: 0, sm: open ? `${drawerWidth}px` : 0 },
                        right: { xs: 0, sm: notificationDrawerOpen ? "300px" : "0px" },
              transition: "width 0.0s",
            }}
          >
            <Toolbar sx={{ mr: { xs: 0, sm: "24px" }, px: { xs: 1.25, sm: 3 } }}>
              <IconButton
                edge="start"
                color="#2F3D63"
                aria-label="open drawer"
                            onClick={toggleDrawer}
                            sx={{
                                marginRight: { xs: 1, sm: "36px" },
                                ...(open && { display: "none" }),
                            }}
              >
                <MenuIcon />
              </IconButton>
                        <Box sx={{ display: "flex", alignItems: "center", gap: "25px" }}>
              <Typography
                                sx={{ flexGrow: 1, fontSize: { xs: 20, sm: isPlatformWorkspace ? 20 : (adminAction ? 25 : 38) }, lineHeight: { xs: 1.2, sm: 1.35 } }}
                style={{
                  color: ColorEnum.DARK_BLUE,
                  fontFamily: "Rubik, sans-serif",
                  fontWeight: isPlatformWorkspace ? "650" : "500",
                  padding: "0px 0px",
                }}
              >
                                {adminAction
                                    ? (isExecutiveDashboard ? `${tenantName} overview` : `Tenant Dashboard - ${tenantName}`)
                                    : (isPlatformWorkspace ? "Administration" : headerText)}
              </Typography>
                            {isSupportPreview && (
                                <Stack direction="row" spacing={1} alignItems="center">
                                    <Button
                                        size="small"
                                        startIcon={<VisibilityOutlinedIcon />}
                                        onClick={() => window.location.assign(`/platform/tenant/${URLTenant}`)}
                                        sx={{
                                            color: "#92400e",
                                            backgroundColor: "#fef3c7",
                                            border: "1px solid #f59e0b",
                                            textTransform: "none",
                                            whiteSpace: "nowrap",
                                            "&:hover": { backgroundColor: "#fde68a" },
                                        }}
                                    >
                                        Viewing as {supportPreview?.name || supportPreview?.email || "user"} · Read-only
                                    </Button>
                                    <Button
                                        size="small"
                                        onClick={() => window.location.assign(`/platform/tenant/${URLTenant}`)}
                                        sx={{ textTransform: "none", whiteSpace: "nowrap" }}
                                    >
                                        Exit preview
                                    </Button>
                                </Stack>
                            )}
                            {tenantType !== "payment_platform" && ((!adminAction && !isAdmin && location.pathname === "/") || (adminAction && location.pathname === `/tenant-dashboard/${URLTenant}`)) ? (
                                <Box sx={{ height: "100%" }}>
                                    <Stack
                                        direction="row"
                                        spacing={1}
                                        alignItems="center"
                                        sx={{ marginRight: "auto" }}
                                    >
                  <Typography style={{ color: "#2F3D63" }}>
                    Account Receivable
                  </Typography>
                                        <AntSwitch
                    checked={isProspects}
                                            inputProps={{
                                                "aria-label": "ant design",
                                            }}
                    onChange={handleSwitchClick}
                  />
                  <Typography style={{ color: "#2F3D63" }}>
                    Prospects
                  </Typography>
                </Stack>
                                </Box>
              ) : null}
                        </Box>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end",
                                marginLeft: "auto",
                            }}
                        >
                            {location.pathname === "/company" || (adminAction && location.pathname === `/tenant-dashboard/${URLTenant}/company`) ? (
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        flexDirection: notificationDrawerOpen
                                            ? "column"
                                            : "row",
                                        gap: "0px",
                                    }}
                                >
                                    <Button
                                        onClick={handleFilterOpen}
                                        sx={{
                                            fontSize: "14px",
                                            textTransform: "none",
                                            color: "#5186EC",
                                            fontWeight: "400",
                                            minWidth: "0px",
                                        }}
                                    >
                                        <img src={filterIcon} width="15px" />
                                        Filters
                                    </Button>
                                </Box>
                            ) : null}
                            {location.pathname === "/company" || (adminAction && location.pathname === `/tenant-dashboard/${URLTenant}/company`) ||
                                location.pathname === "/aichat" || (adminAction && location.pathname === `/tenant-dashboard/${URLTenant}/aichat`) ? (
                                <SearchBar />
                            ) : null}

                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "left",
                                    flexDirection: "column",
                                    justifyContent: "flex-end",
                                }}
                            >
                                <IconButton
                                    aria-label="account of current user"
                                    aria-controls="menu-appbar"
                                    aria-haspopup="true"
                                    onClick={handleMenu}
                                    color="inherit"
                                    sx={{
                                        width: "45px",
                                        height: "45px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        borderRadius: "50%",
                                        boxShadow: "0px 3px 6px #00000029",
                                        margin: "10px",
                                    }}
                                >
                                    {darkLogo ? (
                                        <img
                                            src={darkLogo}
                                            alt=""
                                            style={{
                                                maxWidth: "100%",
                                                maxHeight: "100%",
                                                objectFit: "contain",
                                            }}
                                        />
                                    ) : (
                                        <img
                                            src="/logo-dark.png"
                                            alt=""
                                            style={{
                                                maxWidth: "100%",
                                                maxHeight: "100%",
                                                objectFit: "contain",
                                            }}
                                        />
                                    )}
                                </IconButton>
                                <Menu
                                    id="menu-appbar"
                                    anchorEl={anchorMenu}
                                    anchorOrigin={{
                                        vertical: "top",
                                        horizontal: "right",
                                    }}
                                    keepMounted
                                    transformOrigin={{
                                        vertical: "top",
                                        horizontal: "right",
                                    }}
                                    style={{ top: "50px" }}
                                    open={Boolean(anchorMenu)}
                                    onClose={handleCloseMenu}
                                >
                                    <MenuItem onClick={handleLogout}>
                                        Log out
                                    </MenuItem>
                                </Menu>
                            </Box>
                            <Box>
                                {tenantType === "payment_platform" ? (
                                    <>
                                        <RestrictedAction allowed={permissions.canCreateEntity}>
                                            <Button sx={{ display: isAdmin && location.pathname === "/" ? "none" : "inline" }}>
                                                <Fab
                                                    color="primary"
                                                    aria-label="Add company or data files"
                                                    sx={{ margin: 0, width: "45px", height: "45px", backgroundColor: "#5186EC" }}
                                                    onClick={(event) => setPaymentActionAnchor(event.currentTarget)}
                                                >
                                                    <AddIcon />
                                                </Fab>
                                            </Button>
                                        </RestrictedAction>
                                        <Menu
                                            anchorEl={paymentActionAnchor}
                                            open={Boolean(paymentActionAnchor)}
                                            onClose={() => setPaymentActionAnchor(null)}
                                            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                            transformOrigin={{ vertical: "top", horizontal: "right" }}
                                        >
                                            <MenuItem onClick={() => handlePaymentPlatformAction("addCompany")}>
                                                <ListItemIcon>
                                                    <AddIcon fontSize="small" />
                                                </ListItemIcon>
                                                Add company
                                            </MenuItem>
                                            <MenuItem onClick={() => handlePaymentPlatformAction("uploadData")}>
                                                <ListItemIcon>
                                                    <UploadFile fontSize="small" />
                                                </ListItemIcon>
                                                Upload data files
                                            </MenuItem>
                                            <MenuItem onClick={() => handlePaymentPlatformAction("cloudStorage")}>
                                                <ListItemIcon>
                                                    <CloudQueueOutlinedIcon fontSize="small" />
                                                </ListItemIcon>
                                                Cloud bucket & outputs
                                            </MenuItem>
                                        </Menu>
                                    </>
                                ) : show_add_company_button &&
                                    isAREnabled &&
                                    isProspects === false ? (
                                    <Button
                                        sx={{
                                            display:
                                                isAdmin &&
                                                    location.pathname === "/"
                                                    ? "none"
                                                    : "inline",
                                        }}
                                    >
                <RestrictedAction allowed={permissions.canCreateEntity}>
                <Fab
                  color="primary"
                                            aria-label="add"
                  sx={{
                    margin: 0,
                    width: "45px",
                    height: "45px",
                    backgroundColor: "#5186EC",
                  }}
                                            onClick={openModal}
                >
                  <AddIcon />
                </Fab>
                </RestrictedAction>
                                        <FileUploadModal
                                            open={isModalOpen}
                                            close={closeModal}
                                        />
                                    </Button>
                                ) : (
                                    <span onClick={permissions.canCreateEntity && Number(counter) <= 0 ? handleOpenLimitModal : undefined} style={{ display: "inline-block" }}>
                                    <Tooltip title={Number(counter) <= 0 ? "" : ""} arrow>
                                      <span>
                                      <Button
                                        sx={{
                                            display:
                                                isAdmin &&
                                                    location.pathname === "/"
                                                    ? "none"
                                                    : "inline",
                                        }}
                                    >
                                    <RestrictedAction allowed={permissions.canCreateEntity}>
                                    <Fab
                                        color="primary"
                                        aria-label="add"
                                        sx={{
                                        margin: 0,
                                        width: "45px",
                                        height: "45px",
                                        backgroundColor: "#5186EC",
                                        }}
                                        onClick={openModal}
                                        disabled={Number(counter) <= 0}
                                    >
                                        <UploadFile />
                                    </Fab>
                                    </RestrictedAction>
                                        <ProspectFileUploadModal
                                            open={isModalOpen}
                                            onClose={closeModal}
                                            counter={counter}
                                            tenantName = {tenantName}
                                        />
                                    </Button>
                                    <RestrictedAction allowed={permissions.canCreateEntity}>
                                        <Button
                                          sx={{
                                            display: isAdmin && (location.pathname === "/" || location.pathname ==="/requeststatus")? "none" : "inline",
                                          }}
                                          disabled={Number(counter) <= 0}
                                        >
                                        <CreateCompanyModal />
                                        </Button>
                                    </RestrictedAction>
                                      </span>
                                    </Tooltip>
                                  </span>
                                )}
                                <Tooltip title="Help Center" arrow>
                                    <Button
                                        variant="contained"
                                        onClick={() => setHelpOpen(true)}
                                        aria-label="Open Help Center"
                                        style={{
                                            height: 45,
                                            width: 50,
                                            minWidth: 50,
                                            backgroundColor: "white",
                                            padding: 0,
                                            marginLeft: "10px",
                                        }}
                                    >
                                        <HelpOutlineIcon sx={{ color: "#5186EC", fontSize: 26 }} />
                                    </Button>
                                </Tooltip>
                                <Button
                                    variant="contained"
                                    onClick={handleClick}
                                    style={{
                                        height: 45,
                                        width: 50,
                                        minWidth: 50,
                                        backgroundColor: "white",
                                        padding: 0,
                                        marginLeft: "10px",
                                    }}
                                >

                                    <img
                                        src={"/alerticon.svg"}
                                        alt="alert"
                                        height={25}
                                        width={25}
                                    />
                                    {notificationCount > 0 && (
                                        <div
                                            style={{
                                                width: 12,
                                                height: 12,
                                                backgroundColor: "#5186EC",
                                                borderRadius: "50%",
                                                position: "absolute",
                                                top: 10,
                                                right: 11,
                                            }}
                                        />
                                    )}
                                </Button>
                            </Box>
                        </Box>
            </Toolbar>
                    <Modal
                        open={popupOpen}
                        onClose={handleClosePopup}
                        aria-labelledby="ar-disabled-popup-title"
                        aria-describedby="ar-disabled-popup-description"
                    >
                        <Box
                            sx={{
                position: "absolute", 
                top: "50%", 
                left: "50%", 
                                width: "400px",
                transform: "translate(-50%, -50%)", 
                                bgcolor: "background.paper",
                                borderRadius: "20px",
                                boxShadow:
                                    "inset 0px 1px 3px #0000001A, 0px 3px 6px #00000029",
                                padding: "20px",
                                paddingTop: "10px",
                                paddingLeft: "45px",
                            }}
                        >
                            <Typography
                                id="ar-disabled-popup-title"
                                variant="h6"
                                component="h2"
                                sx={{ color: "#2F3D63" }}
                            >
                  Accounts Receivable Not Enabled
                </Typography>
                            <Typography
                                id="ar-disabled-popup-description"
                                sx={{ mt: 2, color: "#3d4e7a" }}
                            >
                                You currently don't have Accounts Receivable
                                enabled. To enable it, please click on the link:
                  <span style={{ marginLeft: "10px" }}>
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        handleSettingsClick();
                      }}
                      style={{
                        color: "#5186EC",
                        textDecoration: "underline",
                        wordWrap: "break-word",
                        cursor: "pointer",
                      }}
                    >
                      go to settings
                    </a>
                  </span>
                </Typography>

                <IconButton
                  sx={{ position: "absolute", top: 5, left: 5 }}
                  onClick={handleClosePopup}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            </Modal>
          </AppBar>
          <Drawer
            variant={isMobile ? "temporary" : "permanent"}
            open={open}
            onClose={() => setOpen(false)}
            ModalProps={{ keepMounted: true }}
            sx={{
              "& .MuiDrawer-paper": {
                position: isMobile ? "fixed" : "relative",
                whiteSpace: "nowrap",
                width: drawerWidth,
                transition: "width 0.3s",
                boxSizing: "border-box",
                overflowX: "hidden",
                ...(open ? { width: drawerWidth } : { width: 0 }),
              },
            }}
          >
            <Toolbar
              sx={{
                display: "flex",
                alignItems: "center",
                            justifyContent: "flex-end",
                            px: [1],
              }}
            >
                {clientDistributor ? <DistributorBrandLockup distributor={clientDistributor} /> : (
                  <img src="/logo.svg" alt="CrediArc" style={{ paddingLeft: 50 }} />
                )}
                        <IconButton onClick={toggleDrawer}>
                <ChevronLeftIcon
                                sx={{
                                    color: ColorEnum.TEXT_WHITE,
                                    fontSize: "16px",
                                }}
                />
              </IconButton>
            </Toolbar>
            <div
              style={{
                height: "calc( 100vh - 64px )",
                display: "flex",
                flexDirection: "column",
                backgroundColor: "#2F3D63",
              }}
            >
                        {(!isAdminUser || adminAction) && (
                            <List
                                component="nav"
                                style={{ flex: 1, overflow: "auto" }}
                            >
                                {show_dashboard && !(isAdmin && !location.pathname === "/") && (
                                    <ListItemButton
                                        onClick={() => {
                                            setSelectedSegment(null);
                                            handleGoToDashboard();
                                            setStatus("DASHBOARD");
                                        }}
                                        selected={isDashboardRoute}
                                        aria-current={isDashboardRoute ? "page" : undefined}
                                    >
                  <ListItemIcon sx={{ minWidth: "35px" }}>
                    {isDashboardRoute ? (
                                                <img
                                                    src={DashboardSVGIconActive}
                                                    alt="Icon"
                                                />
                                            ) : (
                                                <img
                                                    src={DashboardSVGIcon}
                                                    alt="Icon"
                                                />
                                            )}
                                        </ListItemIcon>
                                        <ListItemText
                                            primaryTypographyProps={{
                                                fontSize: 14,
                                            }}
                                            sx={{
                                                color: ColorEnum.TEXT_WHITE,
                                                fontSize: "16px",
                                            }}
                                            primary="Dashboard"
                                        />
                                        {loadingButton === "dashboard" && (
                                            <CircularProgress
                                                size={16}
                                                sx={{ marginLeft: "10px", color: "white" }}
                                            />
                                        )}
                                    </ListItemButton>
                                )}

                                {location.pathname === "/" && !isAdmin && (
                                    <>
                                    <Divider
                                        sx={{
                                            height: "1px",
                                            backgroundColor:
                                                ColorEnum.PRIMARY_BLUE,
                                            mx: 2,
                                        }}
                                    />
                                    <ListItemButton onClick={() => setStatus('APPROVED')}>
                                        <ListItemIcon sx={{ minWidth: "35px" }}>
                                            <img src={RequestStatusIconActive} alt="Icon" />
                                        </ListItemIcon>
                                        <ListItemText
                                            primaryTypographyProps={{ fontSize: 14 }}
                                            sx={{ color: ColorEnum.TEXT_WHITE, fontSize: "16px" }}
                                            primary="Approved"
                                        />
                                    </ListItemButton>
                                    <ListItemButton onClick={() => setStatus('PENDING')}>
                                        <ListItemIcon sx={{ minWidth: "35px" }}>
                                            <img src={RequestStatusIcon} alt="Icon" />
                                        </ListItemIcon>
                                        <ListItemText
                                            primaryTypographyProps={{ fontSize: 14 }}
                                            sx={{ color: ColorEnum.TEXT_WHITE, fontSize: "16px" }}
                                            primary="Pending"
                                        />
                                    </ListItemButton>
                                    </>
                                )}

                                {/* Segments Section */}
                                {!(isAdmin && !location.pathname === "/") && (
                                    <>
                                        <ListItemButton onClick={() => {
                                            setSegmentsExpanded(!segmentsExpanded);
                                        }}>
                                            <ListItemIcon  sx={{ minWidth: "35px" }}>
                                                <WidgetsOutlinedIcon outlined sx={{ color: ColorEnum.TEXT_WHITE }} />
                  </ListItemIcon>
                  <ListItemText
                    primaryTypographyProps={{ fontSize: 14 }}
                    sx={{ color: ColorEnum.TEXT_WHITE, fontSize: "16px" }}
                                                primary="Segments"
                                            />
                                            <IconButton sx={{ color: ColorEnum.TEXT_WHITE, padding: 0 }}>
                                                {segmentsExpanded ? (
                                                    <KeyboardArrowDownIcon />
                                                ) : (
                                                    <ChevronRightIcon />
                                                )}
                                            </IconButton>
                </ListItemButton>

                                        {segmentsExpanded && segments.map((segment) => (
                                            <ListItemButton
                                                key={segment.id}
                                                onClick={() => {
                                                    setSelectedSegment(segment);
                                                    handleGoToDashboard();
                                                }}
                                                sx={{ pl: 4, backgroundColor: selectedSegment?.id === segment.id ? ColorEnum.TEXT_DARK_BLUE : "transparent", borderRadius: "10px" }}
                                            >
                                                <ListItemText
                                                    primaryTypographyProps={{ fontSize: 14 }}
                                                    sx={{
                                                        color: ColorEnum.TEXT_WHITE,
                                                        fontSize: selectedSegment?.id === segment.id ? "20px" : "14px",
                                                    }}
                                                    primary={segment.name}
                                                />
                                            </ListItemButton>
                                        ))}
                                    </>
                                )}

                                {show_company && (
                                    <ListItemButton onClick={handleGoToCompanies}>
                                        <ListItemIcon sx={{ minWidth: "35px" }}>
                                            {location.pathname ===
                                                "/company" ? (
                                                <img
                                                    src={
                                                        CompanyCardSVGIconActive
                                                    }
                                                    alt="Icon"
                                                />
                                            ) : (
                                                <img
                                                    src={CompanyCardSVGIcon}
                                                    alt="Icon"
                                                />
                                            )}
                                        </ListItemIcon>
                                        <ListItemText
                                            primaryTypographyProps={{
                                                fontSize: 14,
                                            }}
                                            sx={{
                                                color: ColorEnum.TEXT_WHITE,
                                                fontSize: "16px",
                                            }}
                                            primary="Companies"
                                        />
                                        {loadingButton === "companies" && (
                                            <CircularProgress
                                                size={16}
                                                sx={{ marginLeft: "10px", color: "white" }}
                                            />
                                        )}
                                    </ListItemButton>
                                )}

                                {location.pathname === "/company" && (
                                    <Divider
                                        sx={{
                                            height: "1px",
                                            backgroundColor: ColorEnum.PRIMARY_BLUE,
                                            mx: 2,
                                        }}
                                    />
                                )}

                                {show_request_status && (
                                    <ListItemButton onClick={() => handleGoToRequestStatus()}>
                                        <ListItemIcon sx={{ minWidth: "35px" }}>
                                            {location.pathname === "/requeststatus" || 
                                             location.pathname.includes("/requeststatus") ? (
                                                <img
                                                    src={RequestStatusIconActive}
                                                    alt="Icon"
                                                />
                                            ) : (
                                                <img
                                                    src={RequestStatusIcon}
                                                    alt="Icon"
                                                />
                                            )}
                                        </ListItemIcon>
                                        <ListItemText
                                            primaryTypographyProps={{
                                                fontSize: 14,
                                            }}
                                            sx={{
                                                color: ColorEnum.TEXT_WHITE,
                                                fontSize: "16px",
                                            }}
                                            primary="Request Status"
                                        />
                                    </ListItemButton>
                                )}

                                {(location.pathname === "/requeststatus" ||
                                  location.pathname.includes("/requeststatus")) && (
                                    <Divider
                                        sx={{
                                            height: "1px",
                                            backgroundColor: ColorEnum.PRIMARY_BLUE,
                                            mx: 2,
                                        }}
                                    />
                                )}

                                <ListItemButton onClick={() => handleGoToUploadCompanyFiles()}>
                                    <ListItemIcon sx={{ minWidth: "35px" }}>
                                        <UploadFile sx={{ color: "#fff" }} />
                                    </ListItemIcon>
                                    <ListItemText
                                        primaryTypographyProps={{
                                            fontSize: 14,
                                        }}
                                        sx={{
                                            color: ColorEnum.TEXT_WHITE,
                                            fontSize: "16px",
                                        }}
                                        primary="Upload Company Files"
                                    />
                                </ListItemButton>

                                {tenantType === "payment_platform" && (
                                    <ListItemButton onClick={handleGoToAssessments}>
                                        <ListItemIcon sx={{ minWidth: "35px" }}>
                                            <AccountBalanceOutlinedIcon sx={{ color: location.pathname.includes("/assessments") ? "#8FB4F2" : ColorEnum.TEXT_WHITE }} />
                                        </ListItemIcon>
                                        <ListItemText primaryTypographyProps={{ fontSize: 14 }} sx={{ color: ColorEnum.TEXT_WHITE, fontSize: "16px" }} primary="MCA / Loan Models" />
                                    </ListItemButton>
                                )}

                                {location.pathname.includes("/uploadcompanyfiles") && (
                                    <Divider
                                        sx={{
                                            height: "1px",
                                            backgroundColor: ColorEnum.PRIMARY_BLUE,
                                            mx: 2,
                                        }}
                                    />
                                )}

                                <Divider
                                    sx={{
                                        height: "1px",
                                        backgroundColor: "#3753A0",
                                        m: 2,
                                    }}
                                />

                                {show_questions && (
                                    <ListItemButton>
                                        <ListItemIcon sx={{ minWidth: "35px" }}>
                                            {location.pathname ===
                                                "/questions" ? (
                                                <img
                                                    src={QuestionSVGIconActive}
                                                    alt="Icon"
                                                />
                                            ) : (
                                                <img
                                                    src={QuestionSVGIcon}
                                                    alt="Icon"
                                                />
                                            )}
                                        </ListItemIcon>
                                        <ListItemText
                                            primaryTypographyProps={{
                                                fontSize: 14,
                                            }}
                                            sx={{
                                                color: ColorEnum.TEXT_WHITE,
                                                fontSize: "16px",
                                            }}
                                            primary="Questions"
                                            onClick={() =>
                                                handleGoToQuestions()
                                            }
                                        />
                                    </ListItemButton>
                                )}

                                {location.pathname === "/questions" && (
                                    <Divider
                                        sx={{
                                            height: "1px",
                                            backgroundColor:
                                                ColorEnum.PRIMARY_BLUE,
                                            mx: 2,
                                        }}
                                    />
                                )}

                                <ListItemButton onClick={handleGoToPortfolioRisk} dense data-track-label="Open Portfolio Risk">
                                    <ListItemIcon sx={{ minWidth: "35px" }}>
                                        <MonitorHeartOutlinedIcon sx={{ color: location.pathname.includes("/portfolio-risk") ? "#8FB4F2" : ColorEnum.TEXT_WHITE, fontSize: 22 }} />
                                    </ListItemIcon>
                                    <ListItemText
                                        primaryTypographyProps={{ fontSize: 14 }}
                                        sx={{ color: ColorEnum.TEXT_WHITE, fontSize: "16px" }}
                                        primary={<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>Portfolio Risk<Box component="span" sx={{ px: .75, py: .1, borderRadius: "5px", bgcolor: "#FACC15", color: "#173461", fontSize: 9.5, fontWeight: 800, lineHeight: 1.5 }}>NEW</Box></Box>}
                                    />
                                </ListItemButton>

                                {isCurrencyRiskEnabled(activeTenantId) && (
                                    <ListItemButton onClick={handleGoToCurrencyRisk} dense data-track-label="Open Currency Risk">
                                        <ListItemIcon sx={{ minWidth: "35px" }}>
                                            <CurrencyExchangeOutlinedIcon sx={{ color: location.pathname.includes("/currency-risk") ? "#8FB4F2" : ColorEnum.TEXT_WHITE, fontSize: 22 }} />
                                        </ListItemIcon>
                                        <ListItemText
                                            primaryTypographyProps={{ fontSize: 14 }}
                                            sx={{ color: ColorEnum.TEXT_WHITE, fontSize: "16px" }}
                                            primary={<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>Currency Risk<Box component="span" sx={{ px: .75, py: .1, borderRadius: "5px", bgcolor: "#6FE6C5", color: "#173461", fontSize: 9.5, fontWeight: 800, lineHeight: 1.5 }}>PILOT</Box></Box>}
                                        />
                                    </ListItemButton>
                                )}

                                {/* BI & Reporting — new, client-facing (30-day free-trial preview + guided tour). */}
                                <ListItemButton
                                    onClick={() => handleGoToReporting()}
                                    dense
                                >
                                    <ListItemIcon sx={{ minWidth: "35px" }}>
                                        <InsightsIcon
                                            sx={{
                                                color: location.pathname.includes("/reporting")
                                                    ? "#8FB4F2"
                                                    : ColorEnum.TEXT_WHITE,
                                                fontSize: 22,
                                            }}
                                        />
                                    </ListItemIcon>
                                    <ListItemText
                                        primaryTypographyProps={{ fontSize: 14 }}
                                        sx={{
                                            color: ColorEnum.TEXT_WHITE,
                                            fontSize: "16px",
                                        }}
                                        primary={
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                <span>BI &amp; Reporting</span>
                                                <Box
                                                    component="span"
                                                    sx={{
                                                        fontSize: 9.5,
                                                        fontWeight: 800,
                                                        letterSpacing: ".06em",
                                                        color: "#0E2A5A",
                                                        background: "#FFD34E",
                                                        borderRadius: "6px",
                                                        px: 0.75,
                                                        py: "1px",
                                                        lineHeight: 1.7,
                                                    }}
                                                >
                                                    NEW
                                                </Box>
                                            </Box>
                                        }
                                    />
                                </ListItemButton>

                                {location.pathname.includes("/reporting") && (
                                    <Divider
                                        sx={{
                                            height: "1px",
                                            backgroundColor:
                                                ColorEnum.PRIMARY_BLUE,
                                            mx: 2,
                                        }}
                                    />
                                )}

                                {/* Insurance — gated on the tenant's plan/features entitlement. */}
                                {insuranceEnabled && (
                                    <ListItemButton onClick={() => handleGoToInsurance()} dense>
                                        <ListItemIcon sx={{ minWidth: "35px" }}>
                                            <ShieldIcon
                                                sx={{
                                                    color: location.pathname.includes("/insurance")
                                                        ? "#8FB4F2"
                                                        : ColorEnum.TEXT_WHITE,
                                                    fontSize: 22,
                                                }}
                                            />
                                        </ListItemIcon>
                                        <ListItemText
                                            primaryTypographyProps={{ fontSize: 14 }}
                                            sx={{ color: ColorEnum.TEXT_WHITE, fontSize: "16px" }}
                                            primary="Insurance"
                                        />
                                    </ListItemButton>
                                )}

                                {/* Billing & Plans — admin-only for now (not yet GA). */}
                                {isAdmin && (
                                    <ListItemButton
                                        onClick={() => handleGoToBilling()}
                                        dense
                                    >
                                        <ListItemIcon sx={{ minWidth: "35px" }}>
                                            <CreditCardIcon
                                                sx={{
                                                    color: location.pathname.includes("/billing")
                                                        ? "#8FB4F2"
                                                        : ColorEnum.TEXT_WHITE,
                                                    fontSize: 22,
                                                }}
                                            />
                                        </ListItemIcon>
                                        <ListItemText
                                            primaryTypographyProps={{ fontSize: 14 }}
                                            sx={{
                                                color: ColorEnum.TEXT_WHITE,
                                                fontSize: "16px",
                                            }}
                                            primary="Billing & Plans"
                                        />
                                    </ListItemButton>
                                )}

                                {/* Platform Console — internal CrediArc platform admins only. */}
                                {platformAdmin && (
                                    <ListItemButton
                                        onClick={() => handleGoToPlatform()}
                                        dense
                                    >
                                        <ListItemIcon sx={{ minWidth: "35px" }}>
                                            <AdminPanelSettingsIcon
                                                sx={{
                                                    color: location.pathname.includes("/platform")
                                                        ? "#8FB4F2"
                                                        : ColorEnum.TEXT_WHITE,
                                                    fontSize: 22,
                                                }}
                                            />
                                        </ListItemIcon>
                                        <ListItemText
                                            primaryTypographyProps={{ fontSize: 14 }}
                                            sx={{
                                                color: ColorEnum.TEXT_WHITE,
                                                fontSize: "16px",
                                            }}
                                            primary="Platform Console"
                                        />
                                    </ListItemButton>
                                )}

                                {/* API & documentation — available to all tenants. */}
                                <ListItemButton
                                    onClick={() => handleGoToApi()}
                                    dense
                                >
                                    <ListItemIcon sx={{ minWidth: "35px" }}>
                                        <IntegrationInstructionsIcon
                                            sx={{
                                                color: location.pathname.endsWith("/api")
                                                    ? "#8FB4F2"
                                                    : ColorEnum.TEXT_WHITE,
                                                fontSize: 22,
                                            }}
                                        />
                                    </ListItemIcon>
                                    <ListItemText
                                        primaryTypographyProps={{ fontSize: 14 }}
                                        sx={{ color: ColorEnum.TEXT_WHITE, fontSize: "16px" }}
                                        primary="API & Docs"
                                    />
                                </ListItemButton>

                                {show_settings && (
                                    <ListItemButton
                                        onClick={() =>
                                            handleGoToSettings()
                                        }
                                        dense
                                    >
                                        <ListItemIcon
                                            sx={{ minWidth: "35px" }}
                                        >
                                            {location.pathname ===
                                                "/settings" ? (
                                                <img
                                                    src={
                                                        SettingSVGIconActive
                                                    }
                                                    alt="Icon"
                                                />
                                            ) : (
                                                <img
                                                    src={SettingSVGIcon}
                                                    alt="Icon"
                                                />
                                            )}
                                        </ListItemIcon>
                                        <ListItemText
                                            primaryTypographyProps={{
                                                fontSize: 14,
                                            }}
                                            sx={{
                                                color: ColorEnum.TEXT_WHITE,
                                                fontSize: "16px",
                                            }}
                                            primary="Settings"
                                        />
                                    </ListItemButton>
                                )}

                                {location.pathname === "/settings" && (
                                    <Divider
                                        sx={{
                                            height: "1px",
                                            backgroundColor:
                                                ColorEnum.PRIMARY_BLUE,
                                            mx: 2,
                                        }}
                                    />
                                )}
              </List>
                        )}
                        {isAdminUser && !adminAction && (
                            <List component="nav" style={{ flex: 1, overflow: "auto" }}>
                                <ListItemButton onClick={handleGoToAdmin}>
                                    <ListItemIcon sx={{ minWidth: "35px" }}>
                                        <BarChartIcon sx={{ color: "#fff" }} />
                                    </ListItemIcon>
                                    <ListItemText
                                        primaryTypographyProps={{ fontSize: 14 }}
                                        primary="Admin Console"
                                        sx={{ color: "#fff" }}
                                    />
                                </ListItemButton>

                                {show_request_status && (
                                    <ListItemButton onClick={handleGoToRequestStatus}>
                                        <ListItemIcon sx={{ minWidth: "35px" }}>
                                            {location.pathname === "/requeststatus" || 
                                             location.pathname.includes("/requeststatus") ? (
                                                <img src={RequestStatusIconActive} alt="Icon" />
                                            ) : (
                                                <img src={RequestStatusIcon} alt="Icon" />
                                            )}
                                        </ListItemIcon>
                                        <ListItemText
                                            primaryTypographyProps={{ fontSize: 14 }}
                                            sx={{ color: ColorEnum.TEXT_WHITE, fontSize: "16px" }}
                                            primary="Request Status"
                                        />
                                    </ListItemButton>
                                )}
                            </List>
                        )}
              {activeTenantId && (
                <Box sx={{ mx: 2, mb: 1.5 }}>
                  <Button
                    fullWidth
                    onClick={() => setInviteTeamOpen(true)}
                    startIcon={<GroupAddIcon />}
                    sx={{
                      textTransform: "none",
                      fontWeight: 600,
                      fontSize: 14,
                      color: "#fff",
                      borderRadius: "10px",
                      border: "1px solid rgba(255,255,255,.32)",
                      py: 1,
                      justifyContent: "flex-start",
                      "&:hover": { background: "rgba(255,255,255,.12)", borderColor: "rgba(255,255,255,.5)" },
                    }}
                  >
                    Invite team member
                  </Button>
                </Box>
              )}

              <Card
                sx={{
                  mx: 2,
                  my: 2,
                  backgroundColor: "#3A538C",
                  maxHeight: 160,
                  position: "relative",
                }}
              >
                <CardContent
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "60px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                                    {clientDistributor ? (
                      <DistributorBrandLockup distributor={clientDistributor} />
                    ) : logo ? (
                    <img
                      src={logo}
                        alt=""
                        style={{
                          maxWidth: "100%",
                          maxHeight: "100%",
                          objectFit: "contain",
                          marginRight: "auto",
                        }}
                      />
                    ) : (
                      <img
                        src="/logo.svg"
                        alt="CrediArc"
                        style={{
                          maxWidth: "100%",
                          maxHeight: "100%",
                          objectFit: "contain",
                        }}
                      />
                                    )}
                  </div>
                  <List>
                    <Typography color={ColorEnum.TEXT_WHITE}>
                      Hello {user?.name}
                    </Typography>
                    <ListItem
                                        sx={{
                                            right: 15,
                                            cursor: "pointer",
                                            zIndex: "5",
                                        }}
                      onClick={handleLogout}
                    >
                      <ListItemIcon sx={{ minWidth: "35px" }}>
                                            <img
                                                src={logoutIcon}
                                                width="22"
                                                height="22"
                                            />
                      </ListItemIcon>
                      <ListItemText
                                            primaryTypographyProps={{
                                                fontSize: 14,
                                            }}
                                            sx={{
                                                color: ColorEnum.TEXT_WHITE,
                                                cursor: "pointer",
                                            }}
                        primary="Logout"
                        onClick={handleLogout}
                      />
                    </ListItem>
                  </List>
                </CardContent>
              </Card>
            </div>
          </Drawer>
          <Box
            component="main"
            sx={{
              backgroundColor: isExecutiveDashboard ? "#f5f7fb" : "#ECEDF0",
              flexGrow: 1,
              minWidth: 0,
              width: { xs: "100%", sm: "auto" },
              height: "100vh",
              overflow: "auto",
            }}
          >
            <Toolbar />
            <Container
              maxWidth={isPlatformWorkspace ? false : (isExecutiveDashboard ? "xl" : "lg")}
              sx={isPlatformWorkspace ? {
                mt: { xs: 1, sm: 2 }, mb: 0, px: 0,
              } : {
                mt: { xs: 2, sm: isExecutiveDashboard ? 3 : 4 }, mb: 4,
                px: { xs: 1.25, sm: isExecutiveDashboard ? 3.5 : 3 },
              }}
            >
              {isSupportPreview && (
                <Box
                  role="status"
                  sx={{
                    mb: 2,
                    px: 2,
                    py: 1.25,
                    borderRadius: 1.5,
                    color: "#78350f",
                    backgroundColor: "#fffbeb",
                    border: "1px solid #fbbf24",
                  }}
                >
                  <Typography sx={{ fontWeight: 700, fontSize: 14 }}>
                    Support preview: {supportPreview?.email}
                  </Typography>
                  <Typography sx={{ fontSize: 13 }}>
                    You see this tenant through the selected user&apos;s role. Changes are disabled.
                  </Typography>
                </Box>
              )}
              <Outlet context={{ setPortfolioCopilotContext }}></Outlet>
            </Container>
          </Box>
                {!isDistributorAdminRoute && (
                    <NotificationDrawer
                        open={notificationDrawerOpen}
                        close={() => setNotificationDrawerOpen(false)}
                        onNotificationCountChange={onNotificationCountChange}
                    />
                )}
                <HelpCenter open={helpOpen} onClose={() => setHelpOpen(false)} />
                {tenantType === "payment_platform" && activeTenantId && (
                    <PaymentPlatformQuickUploadFlow
                        ref={paymentPlatformUploadRef}
                        tenantId={activeTenantId}
                    />
                )}
                <Modal open={isLimitModalOpen} onClose={handleCloseLimitModal}>
                    <Box sx={{ 
                        position: "absolute", 
                        top: "50%", 
                        left: "50%", 
                        transform: "translate(-50%, -50%)", 
                        width: 400, 
                        bgcolor: "white", 
                        boxShadow: 24, 
                        p: 3, 
                        borderRadius: "8px",
                        textAlign: "center"
                        }}>
                        <Typography variant="h6">
                        Based on your contract, you can add up to 0 additional companies.
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 2, mb: 3 }}>
                        Click below to increase the allowed number of companies.
                        </Typography>
                        <Button
                        variant="contained"
                        onClick={() => {
                            handleOnClickBuyMoreCompanies();
                            handleCloseLimitModal();
                        }}
                        >
                        Send Request
                        </Button>
                    </Box>
                    </Modal>
        </Box>
      </ThemeProvider>
    );
}

export default Dashboard;
